export const translations = {
  en: {
    brand: "Jayek",
    tagline: "Hungry? We deliver happiness.",
    heroTitle: "Your next favorite meal is one tap away.",
    heroSubtitle: "Order from the best local restaurants. Fast, warm, and always fresh.",
    searchPlaceholder: "Search restaurants or dishes…",
    browseRestaurants: "Browse Restaurants",
    orderNow: "Order now",
    categories: "Categories",
    featured: "Featured Restaurants",
    topRated: "Top rated",
    min: "min",
    deliveryFee: "Delivery",
    minOrder: "Min order",
    viewMenu: "View menu",
    addToCart: "Add",
    cart: "Cart",
    emptyCart: "Your cart is empty",
    startOrdering: "Start ordering to fill it with goodness.",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Checkout",
    placeOrder: "Place order",
    deliveryAddress: "Delivery address",
    paymentMethod: "Payment method",
    cash: "Cash on delivery",
    card: "Credit/Debit Card",
    label: "Label (Home, Office…)",
    street: "Street address",
    city: "City",
    notes: "Delivery notes (optional)",
    signIn: "Sign in",
    signUp: "Sign up",
    login: "Login",
    register: "Create account",
    email: "Email",
    password: "Password",
    name: "Full name",
    continueWithGoogle: "Continue with Google",
    or: "or",
    profile: "Profile",
    myOrders: "My orders",
    logout: "Log out",
    welcome: "Welcome back",
    noOrders: "No orders yet.",
    orderPlaced: "Order placed",
    preparing: "Preparing",
    onTheWay: "On the way",
    delivered: "Delivered",
    orderSummary: "Order summary",
    restaurants: "Restaurants",
    filter: "Filter",
    all: "All",
    rating: "Rating",
    paymentSuccess: "Payment successful!",
    paymentChecking: "Confirming payment…",
    paymentFailed: "Payment failed. Please try again.",
    continueShopping: "Continue shopping",
    trackOrder: "Track order",
    required: "Required",
    processing: "Processing…",
    addItem: "Add to cart",
    quantity: "Qty",
    remove: "Remove",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    switchToArabic: "العربية",
    switchToEnglish: "English",
    yourBasket: "Your basket",
    items: "items",
    loginToContinue: "Please sign in to continue checkout.",
    signInCta: "Sign in",
    minimumOrder: "Min. order",
    backToMenu: "Back to menu",
    deliveryIn: "Delivery in",
    popular: "Popular",
    save: "Save",
    confirm: "Confirm",
    step1: "Address",
    step2: "Payment",
    step3: "Review",
    next: "Next",
    back: "Back",
  },
  ar: {
    brand: "جايك",
    tagline: "جوعان؟ نوصل لك السعادة.",
    heroTitle: "وجبتك المفضلة القادمة على بُعد نقرة.",
    heroSubtitle: "اطلب من أفضل المطاعم. سريع، دافئ، وطازج دائمًا.",
    searchPlaceholder: "ابحث عن مطعم أو طبق…",
    browseRestaurants: "تصفّح المطاعم",
    orderNow: "اطلب الآن",
    categories: "الأصناف",
    featured: "مطاعم مميزة",
    topRated: "الأعلى تقييمًا",
    min: "دقيقة",
    deliveryFee: "التوصيل",
    minOrder: "الحد الأدنى",
    viewMenu: "عرض القائمة",
    addToCart: "أضف",
    cart: "السلة",
    emptyCart: "سلتك فارغة",
    startOrdering: "ابدأ الطلب وامتع نفسك.",
    subtotal: "المجموع الفرعي",
    total: "الإجمالي",
    checkout: "إتمام الطلب",
    placeOrder: "تأكيد الطلب",
    deliveryAddress: "عنوان التوصيل",
    paymentMethod: "طريقة الدفع",
    cash: "الدفع عند الاستلام",
    card: "بطاقة ائتمان/خصم",
    label: "الاسم (المنزل، العمل…)",
    street: "العنوان",
    city: "المدينة",
    notes: "ملاحظات التوصيل (اختياري)",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    login: "دخول",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    continueWithGoogle: "المتابعة مع Google",
    or: "أو",
    profile: "الملف الشخصي",
    myOrders: "طلباتي",
    logout: "تسجيل الخروج",
    welcome: "أهلاً بعودتك",
    noOrders: "لا توجد طلبات بعد.",
    orderPlaced: "تم الطلب",
    preparing: "قيد التحضير",
    onTheWay: "في الطريق",
    delivered: "تم التوصيل",
    orderSummary: "ملخص الطلب",
    restaurants: "المطاعم",
    filter: "تصفية",
    all: "الكل",
    rating: "التقييم",
    paymentSuccess: "تم الدفع بنجاح!",
    paymentChecking: "جاري تأكيد الدفع…",
    paymentFailed: "فشل الدفع، حاول مجددًا.",
    continueShopping: "متابعة التسوق",
    trackOrder: "تتبع الطلب",
    required: "مطلوب",
    processing: "جاري المعالجة…",
    addItem: "أضف للسلة",
    quantity: "الكمية",
    remove: "إزالة",
    alreadyHaveAccount: "لديك حساب مسبقًا؟",
    noAccount: "ليس لديك حساب؟",
    switchToArabic: "العربية",
    switchToEnglish: "English",
    yourBasket: "سلتك",
    items: "عناصر",
    loginToContinue: "الرجاء تسجيل الدخول للمتابعة.",
    signInCta: "تسجيل الدخول",
    minimumOrder: "الحد الأدنى",
    backToMenu: "رجوع للقائمة",
    deliveryIn: "التوصيل خلال",
    popular: "الأكثر طلبًا",
    save: "حفظ",
    confirm: "تأكيد",
    step1: "العنوان",
    step2: "الدفع",
    step3: "مراجعة",
    next: "التالي",
    back: "السابق",
  },
};

export const t = (lang, key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
